export default __webpack_public_path__ + "f7ffd77d709eb742c5628dbdd786584e.svg";